function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import $dom from 'cash-dom';
import _isArray from 'lodash.isarray';
import _mergeWith from 'lodash.mergewith';
/**
 *
 * @param {Array.<String>} selectors
 */

export var getJSONfromDOM = function getJSONfromDOM(selectors) {
  var jsonArray = selectors.map(function (selector) {
    var $elem = $dom(selector);

    if ($elem.length === 0) {
      console.error("Vuex needs a JSON data element with a selector of ".concat(selector, " in order to init"));
      return {};
    } // If the selector returns one element, simply parse the JSON data inside


    if ($elem.length === 1) {
      try {
        var parsed = JSON.parse($elem.html());
        return parsed;
      } catch (e) {
        console.error("The init data in the element ".concat(selector, " is not parseable JSON: ").concat(e.message));
        return {};
      }
    } // If the selector returns multiple elements, we parse the separate JSON objects
    // and merge them into one, concatenating any identically named properties that are arrays


    if ($elem.length > 1) {
      try {
        var _parsed = [];
        $elem.each(function () {
          _parsed.push(JSON.parse($dom(this).html()));
        });
        return _mergeWith.apply(void 0, _parsed.concat([function (objValue, srcValue) {
          if (_isArray(objValue)) {
            return _toConsumableArray(new Set(objValue.concat(srcValue)));
          }
        }]));
      } catch (e) {
        console.error("The init data in one of the elements matching ".concat(selector, " is not parseable JSON: ").concat(e.message));
        return {};
      }
    }
  });
  return Object.assign.apply(Object, _toConsumableArray(jsonArray));
};